import request from '@/utils/request'

// 0601 获取背景图
export function querybackground (data) {
  return request({
    url: '/background/list',
    method: 'post',
    data
  })
}
